import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { WhyChoose } from './components/WhyChoose';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { DetailedTestimonials } from './components/DetailedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/tmoM3QPgSs3tumHqJ5iocx/hf_20260516_163314_aa7428a1-182f-493a-9299-dd713a79f6f8.png';
    document.head.appendChild(imgLink);
  }, []);
  return <main className="w-full min-h-screen bg-light selection:bg-electric selection:text-navy overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <div className="bg-electric text-navy font-bold md:text-sm text-center py-2 px-4 uppercase tracking-wider text-[10px]" data-id="element-2">
        ACCESO INMEDIATO | 80% DE DESCUENTO SOLO POR HOY
      </div>
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductBreakdown data-id="element-6" />
      <Bonuses data-id="element-7" />
      <WhyChoose data-id="element-8" />
      <Countdown data-id="element-9" />
      <Pricing data-id="element-10" />
      <DetailedTestimonials data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </main>;
}